namespace $.$$ {
	
	export class $shm_hitalama_duckdb_page extends $.$shm_hitalama_duckdb_page {

		@ $mol_mem
		project_id( next?: string ) {
			return next ?? (this.projects().at(0)?.link().toString() ?? '')
		}

		@ $mol_mem
		logs_project_id( next?: string ): string {
			return next ?? (this.project_id() ?? '')
		}

		projects_dict() {
			const dict = {
				...Object.fromEntries( this.projects().map( p => [ p.link().toString(), p.title() ] ) ),
			}
			return dict
		}

		@ $mol_mem
		project() {
			if( !this.project_id() ) return null
			return $giper_baza_glob.Pawn( new $giper_baza_link( this.project_id() ), $shm_hitalama_project )
		}

		@ $mol_mem
		projects() {
			return $shm_hitalama_domain.instance().projects()?.remote_list() ?? []
		}

		files_label() {
			return this.project_id() ? super.files_label() : []
		}

		@ $mol_mem
		files() {
			return this.project()?.Files()?.remote_list() ?? []
		}

		@ $mol_mem
		file_views() {
			return this.files().map( f => this.File( f.link().toString() ) ) ?? []
		}

		@ $mol_mem
		files_checked() {
			return this.files().filter( f => this.file_checked( f.link().toString() ) ) ?? []
		}

		@ $mol_mem_key
		file_name( id: string ) {
			const file = $giper_baza_glob.Pawn( new $giper_baza_link( id ), $shm_hitalama_file )
			return file.title() ?? ''
		}

		@ $mol_mem_key
		query_default( file_id: string ) {
			const name = this.file_name( file_id )
			return name ? `SELECT * FROM parquet_scan('${name}');` : ''
		}

		@ $mol_action
		get_last_query() {
			console.log('this.project_id()', this.project_id())
			if( !this.project_id() ) return null
			const project = $giper_baza_glob.Pawn( new $giper_baza_link( this.project_id() ), $shm_hitalama_project )
			return project.Query_logs()?.remote_list()?.at(-1)?.Query()?.val()
		}

		@ $mol_mem
		query( next?: string ): string {
			if( next !== undefined ) return next

			const last_query = this.get_last_query()
			console.log('last_query', last_query)
			if( last_query ) return last_query

			const file_id = this.files()?.[0]?.link().toString()
			return file_id ? this.query_default( file_id! ) : ''
		}

		run( next?: any ) {
			this.query_current( this.query() )
			const log = this.project()?.Query_logs(null)?.make(null)
			log?.Query(null)!.val( this.query() )
			log?.Time(null)!.val( (new $mol_time_moment).valueOf() )
		}

		@ $mol_mem
		duckdb_res() {
			if( !this.query_current() ) return null
			
			const table_arr = $mol_wire_sync(this).conn_query( this.query_current() ).toArray().slice(0,100)
			const result = table_arr.map( ( row: any ) => row.toJSON() )
			return result
		}

		@ $mol_action
		conn_query( query: string ) {
			return $shm_duckdb.connect_files( this.files_checked() ).query( query )
		}

		@ $mol_mem_key
		query_log( ref: $giper_baza_link ) {
			return $giper_baza_glob.Pawn( ref, $shm_hitalama_project_query_log )
		}

		@ $mol_mem_key
		query_time( ref: $giper_baza_link ) {
			const val = this.query_log( ref ).Time()?.val()!
			const moment = new $mol_time_moment( val )
			return moment.toString( 'YYYY-MM-DD hh:mm:ss' )
		}

		@ $mol_mem_key
		query_sql( ref: $giper_baza_link ) {
			return this.query_log( ref ).Query()?.val() ?? ''
		}

		@ $mol_mem
		logs() {
			if( !this.logs_project_id() ) return []
			const project = $giper_baza_glob.Pawn( new $giper_baza_link( this.logs_project_id() ), $shm_hitalama_project )
			return project.Query_logs()?.remote_list().map( l => this.Query_log( l.link() ) ).reverse() ?? []
		}

		@ $mol_action
		logs_clear() {
			this.project()?.Query_logs()?.remote_list( [] )
		}

	}

}
